module.exports = __webpack_public_path__ + "static/media/adc_hub.32e1e0c1.png";